import { SET_USER } from '../actions'

export default (user = {}, action) => {
  switch (action.type) {
    case SET_USER: 
      return action.payload;
    default:
      return user;
  }
}